// extracted by mini-css-extract-plugin
export default {"card":"GZ-z","carouselContainer":"HZ-z","carouselContent":"IZ-z"};